/**
 * Filters a report data source can apply — mirrors the backend `ReportFilterField` enum
 * (returned per report type in `GET /reports/columns`).
 */
export enum ReportFilterFieldDTO {
  MEMBER = 'MEMBER',
  DEPARTMENT = 'DEPARTMENT',
  ROLE = 'ROLE',
  SENIORITY = 'SENIORITY',
  MEMBER_MANAGER = 'MEMBER_MANAGER',
  MEMBERSHIP_TYPE = 'MEMBERSHIP_TYPE',
  LOCATION = 'LOCATION',
  MEMBER_CUSTOM_ATTRIBUTE = 'MEMBER_CUSTOM_ATTRIBUTE',
  PROJECT = 'PROJECT',
  CLIENT = 'CLIENT',
  PROJECT_STATUS = 'PROJECT_STATUS',
  PROJECT_MANAGER = 'PROJECT_MANAGER',
  BILLING_MODEL = 'BILLING_MODEL',
}
